export default () => {
  const items = document.querySelectorAll('.js-fadeIn, #js-content > *');

  const options = {
    root: null,
    rootMargin: '-20% 0px',
    threshold: 0,
  };

  const callback = (entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('is-show');
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);

  items.forEach((item) => {
    observer.observe(item);
  });
};
